<template>
  <svg
    width="12"
    height="20"
    viewBox="0 0 12 20"
    fill="#3c5fa3"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.165039 18.13L1.93504 19.9L11.835 9.99998L1.93504 0.0999756L0.165039 1.86998L8.29504 9.99998L0.165039 18.13H0.165039Z"
      fill-rule="evenodd"
    />
  </svg>
</template>
